import{jsxs as u,jsx as b}from"react/jsx-runtime";import n,{css as a}from"styled-components";import{hexToRGB as m,resolveColorWithNeutral as f}from"../utils/utils.js";const h=a`
  background-color: transparent;
`,l="400ms",k="1500ms",v="750ms",r=a`
  background-color: ${({theme:e,$color:c,$colorShade:i})=>m(f(e,c)[i],.1)};
  ${e=>e.isDisabled&&h};
`,$=n.div`
  cursor: ${e=>e.isDisabled?"default":"pointer"};
  outline: none;

  display: inline-block;
  position: relative;

  .button-background {
    :focus {
      outline: none;
    }
  }

  &:hover {
    .button-background {
      transition: background-color ${l};
      ${r}
    }
  }

  &:focus {
    .button-background {
      transition: background-color ${l};
      animation: FocusRipple ${k} 0ms infinite alternate-reverse;
      ${r}
    }
  }

  &:active {
    .button-background {
      animation: ActiveRipple ${v};
      ${r}
    }
  }

  @keyframes ActiveRipple {
    0% {
      clip-path: circle(50%);
    }

    25% {
      clip-path: circle(46%);
    }

    100% {
      clip-path: circle(50%);
    }
  }

  @keyframes FocusRipple {
    0% {
      clip-path: circle(46%);
    }

    100% {
      clip-path: circle(50%);
    }
  }
`,g=n.div`
  top: 0;
  left: 0;

  height: calc(100% + 1rem);
  width: calc(100% + 1rem);
  transform: translate(-0.5rem, -0.5rem);

  position: absolute;
  border-radius: 10rem;
`,y=({children:e,isActive:c,isDisabled:i,onClick:t,noTabIndex:s=!1,color:p,colorShade:d="mainAlt"})=>u($,{$color:p,$colorShade:d,isActive:c,isDisabled:i,onClick:o=>{o.stopPropagation(),o.preventDefault(),o.persist(),!i&&typeof t=="function"&&t(o)},onKeyDown:o=>{o.key==="Enter"&&!i&&typeof t=="function"&&(o.persist(),t(o))},tabIndex:i||s?void 0:0,children:[b(g,{className:"button-background"}),e]});export{r as BackgroundStyles,y as default};
